<template>
    <div class="c-image flex-center" :style="{'width': compWidth, 'height': compHeight, 'background': background ? '#F5F5F5' : 'none'}">
		<video v-if="srcType == 'video'" :src="src"></video>
		<img v-else-if="srcType == 'image'" :src="src">
		<i v-else class="icon tf tf-fw tf-file" :class="`tf-file-${suffix}`"></i>
		<a v-if="preview" class="flex-center" @click="previewHandle"><i class="tf tf-search"></i></a>
	</div>
</template>

<script>
	export default {
		props: {
			src: String,
			
			width: [String, Number],
			
			height: [String, Number],
			
			size: [String, Number],
			
			background: {
				type: Boolean,
				default: true
			},
			
			mode: {
				type: String,
				default: 'aspectFit'
			},
			
			type: String,
			
			preview: Boolean
		},
		
		computed: {
			compWidth() {
				if (this.mode == 'heightFix') {
					return 'auto';
				}
				
				return this.parsePixel(this.size || this.width);
			},
			
			compHeight() {
				if (this.mode == 'widthFix') {
					return 'auto';
				}
				
				return this.parsePixel(this.size || this.height);
			},
			
			suffix() {
				if (!this.src || this.src.indexOf('http') !== 0) {
					return 'jpg';
				}
				var arr = this.src.split('?')[0].split('.');
				return arr[arr.length - 1].toLowerCase();
			},
			
			srcType() {
				if (this.type) return this.type;
				let ext = this.suffix;
				if (/(mp4)$/.test(this.suffix)) {
					return 'video';
				}
				if (/(png|jpg|jpe?g|gif)$/.test(this.suffix)) {
					return 'image';
				}
				return ext;
			}
		},
		
		methods: {
			previewHandle() {
				if (['image', 'video'].includes(this.srcType)) {
					this.$preview({
						src: this.src
					});
				} else {
					window.open(this.src);
				}
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-image {
		position: relative;
		width: 100%;
		height: 100%;
		
		video {
			width: 100%;
			height: 100%;
			background: #000;
		}
		
		&:hover a {
			display: flex;
		}
		
		.icon {
			font-size: 26px;
		}
		
		a {
			display: none;
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			font-size: 16px;
			color: #fff;
			background: rgba(0,0,0,.6);
		}
	}
</style>